import { TrackableEntity } from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';
import { GenContainer } from './GenContainer';
import { FileLockProp, InvoiceBillCrdb } from '../ifmsTypes';
import _ from 'lodash';
import { HblInven } from './HblInven';
import { MblStatusViewModel } from './MblStatusViewModel';

export class GenMain extends TrackableEntity {
    modelName: string = "genmain"; //for ifmsButton > getChangedListData

    id: number = 0;
    shipmentType: string = '';
    refNo: string = '';
    branch: string = '';
    category: string = '';
    isfNo: string = '';
    mblNo: string = '';
    hblNo: string = '';
    vesselVoy: string = '';
    agentId: number = 0;
    agentName: string = '';
    customerId: number = 0;
    customerName: string = '';
    customerRefNo: string = '';
    shipper: string = '';
    consignee: string = '';
    commodity: string = '';
    location: string = '';
    containerInfo: string = '';
    genContainerList: GenContainer[] = [];
    unlCode: string = '';
    uslCode: string = '';
    etd: string | null = null;
    loadingPort: string = '';
    undCode: string = '';
    usdCode: string = '';
    eta: string | null = null;
    discharge: string = '';
    unfCode: string = '';
    usfCode: string = '';
    fEta: string | null = null;
    finalDest: string = '';
    itClass: string = '';
    itDate: string | null = null;
    itNo: string = '';
    itPlace: string = '';
    pkgs: number = 0;
    unit: string = '';
    kgs: number = 0;
    lbs: number = 0;
    cbm: number = 0;
    cft: number = 0;
    salespersonId: string = '';
    fileClosed: number = 0;
    closed: boolean = false;
    closedBy: string = '';
    createDate: string | null = null;
    actClosed: boolean = false;
    actClosedBy: string = '';
    actCloseDate: string | null = null;
    internalMemo: string = '';
    remark: string = '';
    closeDate: string | null = null;
    dutyCustomerId: number = 0;
    dutyCustomerName: string = '';
    dutyAgentId: number = 0;
    dutyAgentName: string = '';
    profitShare: number = 0;
    cur1: string = '';
    cur2: string = '';
    exRate1: number = 0;
    exRate2: number = 0;
    completeBill: boolean = false;
    completeInvo: boolean = false;
    completeCrDb: boolean = false;
    confirmDate: string | null = null;
    confirmedBy: string = '';
    confirmActionDate: string | null = null;
    statusInvo: string = '';
    statusBill: string = '';
    statusCrDb: string = '';
    u1Id: string = '';
    u1Date: string | null = null;
    u2Id: string = '';
    u2Date: string | null = null;
    oldVer_Shipper: string = '';
    oldVer_Consignee: string = '';
    oldVer_Location: string = '';
    oldVer_ContainerInfo: string = '';
    isClosed: boolean = false;
    multiNameID: number = 0;
    multiName: string = '';

    operator: string = '';

    invenList: HblInven[] = [];
    volCM: boolean = false;
    // ISalesCostParent.invoiceBill
    invoiceBill: InvoiceBillCrdb | null = null;
    // ISalesCostParent.invoiceBill

    milestone: MblStatusViewModel | null = null;
    milestoneContainerSelectedIndex: number = 0;

    trStatus: string = '';

    get canChangeBranch(): boolean {
        if (this.id <= 0) {
            return true;
        }

        const allowedStatuses = ['', 'E', 'D'];
        return allowedStatuses.includes(this.statusBill) &&
            allowedStatuses.includes(this.statusInvo) &&
            allowedStatuses.includes(this.statusCrDb)
    };

    isFileLockFor(propName: string) {
        return this.isClosed && !GenMain.fileLockEnableProps.some(x => x.key === propName);
    }

    static getFileLockMessage(): string {
        //const messageBase = 'File Locked';
        // return appendLine(messageBase, GenMain.fileLockEnableProps
        //     .map(x => x.name)
        //     .reduce((acc: string, x) => appendLine(acc, `\t${x}`), ""));
        return 'OP Close';
    }

    static fileLockEnableProps: FileLockProp[] = [
        { key: '', name: '' },
    ];

    constructor(init?: Partial<GenMain>) {
        super();
        this.key = 'id';
        Object.assign(this, init);
        this.noTrackProps.push('id', 'closeDate', 'oldVer_AOtherInfoId', 'oldVer_Shipper', 'oldVer_Consignee', 'oldVer_Location', 'oldVer_ContainerInfo',
            'invoiceBill', 'canChangeBranch', 'actClosed', 'actClosedBy', 'actCloseDate', 'isClosed', 'volCM', 'multiName', 'confirmDate', 'confirmedBy', 'trStatus');
        this.getdateProps.push('u1Date', 'u2Date');
        if (this.id === 0) this.id = this.GetNextId();

        if (this.genContainerList.length > 0) {
            this.genContainerList = this.genContainerList.map(d => new GenContainer(d));
        } else {
            this.genContainerList = [];
        }

        if (this.invenList.length > 0) {
            this.invenList = this.invenList.map(d => new HblInven(d));
        } else {
            this.invenList = [];
        }
    }

    getDbMappings(arg?: any): IDictionary<DBMappingInfo> {
        const dicFieldMap: IDictionary<DBMappingInfo> = {};
        _.keys(GenMain.dicFieldMappings).forEach(m => {
            dicFieldMap[m] = GenMain.dicFieldMappings[m];
        });

        _.keys(GenContainer.dicFieldMappings).forEach(m => {
            dicFieldMap[`genContainerList.${m}`] = GenContainer.dicFieldMappings[m];
        });

        _.keys(HblInven.dicFieldMappings).forEach(m => {
            dicFieldMap[`invenList.${m}`] = HblInven.dicFieldMappings[m];
        });
        return dicFieldMap;
    }

    setChildTrackable(value: boolean): void {
        if (this.invenList.length > 0) {
            this.invenList.forEach(c => c.trackable = value);
        }
    }
    static dicFieldMappings: IDictionary<DBMappingInfo> = {
        'shipmentType': new DBMappingInfo({ field: 'F_ShipmentType', table: 'T_GENMAIN' }),
        'refNo': new DBMappingInfo({ field: 'F_RefNo', table: 'T_GENMAIN' }),
        'branch': new DBMappingInfo({ field: 'F_Branch', table: 'T_GENMAIN' }),
        'category': new DBMappingInfo({ field: 'F_Type', table: 'T_GENMAIN' }),
        'isfNo': new DBMappingInfo({ field: 'F_IsfNo', table: 'T_GENMAIN' }),
        'mblNo': new DBMappingInfo({ field: 'F_MblNo', table: 'T_GENMAIN' }),
        'hblNo': new DBMappingInfo({ field: 'F_HblNo', table: 'T_GENMAIN' }),
        'vesselVoy': new DBMappingInfo({ field: 'F_Vessel', table: 'T_GENMAIN' }),
        'agentId': new DBMappingInfo({ field: 'F_Agent', table: 'T_GENMAIN' }),
        'customerId': new DBMappingInfo({ field: 'F_Customer', table: 'T_GENMAIN' }),
        'customerRefNo': new DBMappingInfo({ field: 'F_CustRefNo', table: 'T_GENMAIN' }),
        'shipper': new DBMappingInfo({ field: 'F_Shipper', table: 'T_GENMAIN' }),
        'consignee': new DBMappingInfo({ field: 'F_Consignee', table: 'T_GENMAIN' }),
        'commodity': new DBMappingInfo({ field: 'F_Commodity', table: 'T_GENMAIN' }),
        'location': new DBMappingInfo({ field: 'F_Location', table: 'T_GENMAIN' }),
        'containerInfo': new DBMappingInfo({ field: 'F_ContainerInfo', table: 'T_GENMAIN' }),
        'unlCode': new DBMappingInfo({ field: 'F_UNLCode', table: 'T_GENMAIN' }),
        'uslCode': new DBMappingInfo({ field: 'F_USLCode', table: 'T_GENMAIN' }),
        'etd': new DBMappingInfo({ field: 'F_Etd', table: 'T_GENMAIN' }),
        'loadingPort': new DBMappingInfo({ field: 'F_LoadingPort', table: 'T_GENMAIN' }),
        'undCode': new DBMappingInfo({ field: 'F_UNDCode', table: 'T_GENMAIN' }),
        'usdCode': new DBMappingInfo({ field: 'F_USDCode', table: 'T_GENMAIN' }),
        'eta': new DBMappingInfo({ field: 'F_Eta', table: 'T_GENMAIN' }),
        'discharge': new DBMappingInfo({ field: 'F_Discharge', table: 'T_GENMAIN' }),
        'unfCode': new DBMappingInfo({ field: 'F_UNFCode', table: 'T_GENMAIN' }),
        'usfCode': new DBMappingInfo({ field: 'F_USFCode', table: 'T_GENMAIN' }),
        'fEta': new DBMappingInfo({ field: 'F_FEta', table: 'T_GENMAIN' }),
        'finalDest': new DBMappingInfo({ field: 'F_FinalDest', table: 'T_GENMAIN' }),
        'itClass': new DBMappingInfo({ field: 'F_ITCLASS', table: 'T_GENMAIN' }),
        'itDate': new DBMappingInfo({ field: 'F_ITDate', table: 'T_GENMAIN' }),
        'itNo': new DBMappingInfo({ field: 'F_ITNO', table: 'T_GENMAIN' }),
        'itPlace': new DBMappingInfo({ field: 'F_ITPLACE', table: 'T_GENMAIN' }),
        'pkgs': new DBMappingInfo({ field: 'F_Pkgs', table: 'T_GENMAIN' }),
        'unit': new DBMappingInfo({ field: 'F_PUnit', table: 'T_GENMAIN' }),
        'kgs': new DBMappingInfo({ field: 'F_Kgs', table: 'T_GENMAIN' }),
        'lbs': new DBMappingInfo({ field: 'F_Lbs', table: 'T_GENMAIN' }),
        'cbm': new DBMappingInfo({ field: 'F_Cbm', table: 'T_GENMAIN' }),
        'salespersonId': new DBMappingInfo({ field: 'F_SManId', table: 'T_GENMAIN' }),
        'createDate': new DBMappingInfo({ field: 'F_PostDate', table: 'T_GENMAIN' }),
        'internalMemo': new DBMappingInfo({ field: 'F_IMemo', table: 'T_GENMAIN' }),
        'remark': new DBMappingInfo({ field: 'F_PMemo', table: 'T_GENMAIN' }),
        'cur1': new DBMappingInfo({ field: 'F_Cur1', table: 'T_GENMAIN' }),
        'cur2': new DBMappingInfo({ field: 'F_Cur2', table: 'T_GENMAIN' }),
        'exRate1': new DBMappingInfo({ field: 'F_EXRATE1', table: 'T_GENMAIN' }),
        'exRate2': new DBMappingInfo({ field: 'F_EXRATE2', table: 'T_GENMAIN' }),
        'multiNameID': new DBMappingInfo({ field: 'F_MultiNameID', table: 'T_GENMAIN' }),
        'profitShare': new DBMappingInfo({ field: 'F_ProfitShare', table: 'T_GENMAIN' }),
        'dutyCustomerId': new DBMappingInfo({ field: 'F_DutyCustomer', table: 'T_GENMAIN' }),
        'dutyAgentId': new DBMappingInfo({ field: 'F_DutyAgent', table: 'T_GENMAIN' }),
        'u1Id': new DBMappingInfo({ field: 'F_U1Id', table: 'T_GENMAIN' }),
        'u1Date': new DBMappingInfo({ field: 'F_U1Date', table: 'T_GENMAIN' }),
        'u2Id': new DBMappingInfo({ field: 'F_U2Id', table: 'T_GENMAIN' }),
        'u2Date': new DBMappingInfo({ field: 'F_U2Date', table: 'T_GENMAIN' }),
        'id': new DBMappingInfo({ field: 'F_Id', table: 'T_GENMAIN' }),
        'operator': new DBMappingInfo({ field: 'F_Operator', table: 'T_GENMAIN' }),
    };
}
